var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"roomStatus-wrap"},[_vm._v("roomStatus页面")])
}
var staticRenderFns = []

export { render, staticRenderFns }